import React from "react";
import Header from "./Header";

const AdminProfile = () => {

  const ClientName = localStorage.getItem("username");
  const ClientRole = localStorage.getItem("role");
  const ClientDevices = localStorage.getItem("device_ids");
  
  // Parse the device IDs from string
  let formattedDevices = ClientDevices;
  
  try {
    // If it's a JSON string (like ["device1", "device2"])
    const parsedDevices = JSON.parse(ClientDevices);
    
    if (Array.isArray(parsedDevices)) {
      formattedDevices = parsedDevices.map((device, index) => (
        <div key={index} className="mb-1 last:mb-0">
          {device}
        </div>
      ));
    }
  } catch (e) {
    // If it's not valid JSON, try comma-separated format
    if (ClientDevices && ClientDevices.includes(',')) {
      const deviceArray = ClientDevices.split(',');
      formattedDevices = deviceArray.map((device, index) => (
        <div key={index} className="mb-1 last:mb-0">
          {device.trim()}
        </div>
      ));
    }
  }

  return (
    <>
  <Header/>
  <div className="flex justify-center items-center h-full py-40">
    <div className="bg-primary shadow-lg rounded-lg p-6 w-full max-w-md">
      <div className="flex flex-col items-center">
        <img
          src="/images/client.webp"
          alt="Profile"
          className="w-24 h-24 rounded-full mb-4 shadow-md"
        />
        <h2 className="text-2xl font-semibold text-white">{ClientName}</h2>
        <p className="text-gray-500 text-2xl bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
          {ClientRole}
        </p>
      </div>
      <div className="mt-6 flex justify-between items-center">
      </div>
    </div>
  </div>
</>
  );
};

export default AdminProfile;